import React, { useState} from "react";
import common from "./config/common.json";
import { LoadingSpinner } from "../components/loadingSpinner/LoadingSpinner";
import {useIntl} from 'react-intl';
import './payment/Profilepop.css';


function ChangePassword() {
    const [password, setPassword] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [new_Password, setNewassword] = useState("");
    const [email,setEmail]=useState("")
    const [apiError, setApiError] = useState("");
    const [success, setSuccess] = useState("");
    const intl = useIntl()
    async function changePassword(){
        setIsLoading(true)
        if(new_Password && password){
        var raw = JSON.stringify({ 
            email: email === ""?localStorage.getItem("email"):email,
            "password": password, 
            "new_password": new_Password, 
            "username": email === ""?localStorage.getItem("email"):email , 
            "sip_id": localStorage.getItem("sip_id")
        })
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        setIsLoading(false);
        var requestOptions = { method: "POST",headers: myHeaders, body: raw };
        var res = await fetch(`${common.BASEURL}/chnagePassword`, requestOptions);
        var response = await res.json();
        console.log(response)
        setIsLoading(false);
        var data=JSON.parse(response)
        if (res.status === 200 && data.success === true) {
            setSuccess(data.msg)
            setPassword("")
            setNewassword("")
            setTimeout(()=>{
                setSuccess("")
            },3000)
            setIsLoading(false);
        } else {
            setApiError(data.msg)
            setIsLoading(false);
        }
    }else{
        setApiError(intl.formatMessage({id: "changePasswordMsgError"}))
        setIsLoading(false);  
    }
    }

    return (
        <div>{isLoading ? (
            <LoadingSpinner />
          ):(
        <div className='profilepop'>

        <h3 style={{color:"var(--primary-color)", textAlign:"center",marginTop:"1px",marginBottom:"10px",fontSize:"18px",fontWeight: "400"}}>{intl.formatMessage({id: "changePasswordLable"})}</h3>
                
        <div className="passworderror">{apiError}</div>
        <div className="passwordsuccess">{success}</div>
            <div className='changepassword'>
            <input className='chnageinputbuuton inputChangepassword' type='text'
                value={localStorage.getItem("email")}
                onChange={e => {
                    setEmail(e.target.value)
                    setApiError("")
                }} />
                <input className='chnageinputbuuton inputChangepassword' type='text'
                value={password}
                autoComplete="off"
                onChange={e => {
                        setPassword(e.target.value);
                        setApiError("")
                      }}
                placeholder={intl.formatMessage({id: "oldPasswordLable"})}/>
                <input className='chnageinputbuuton inputChangepassword' type='text'
                value={new_Password}
                autoComplete="off"
                onChange={e => {
                    setNewassword(e.target.value);
                    setApiError("")
                      }}
                placeholder={intl.formatMessage({id: "newPasswordLable"})}/>
                <button className='chengPassword_button_btn' onClick={changePassword}>{intl.formatMessage({id: "changePasswordLable"})}</button>
            </div>
        </div>)}
        </div>

    )
}
export default ChangePassword
